<template>
  <div>
    <div class="sa-row sa-mt20 sa-d-f-a-center">
      <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
        <div class="sa-form-group">
          <input
            type="text"
            class="sa-form-control sa-dark-search"
            placeholder="Search Scientific name"
            v-model="scientific_search"
            @input="changeType"
          /><i class="icon-search sa-search"></i>
        </div>
      </div>
    </div>
    <ul class="sa-infinite sa-infinite-height">
      <li v-for="(item, index) in scientificNames" :key="index">
        <input :value="item" v-model="scientific_name" type="radio" :id="index" :name="index">
        <label :for="index">{{item}}</label>
      </li>
        <infinite-loading :identifier="infiniteId" @infinite="getScientificData" spinner="waveDots">
          <span slot="no-results">No results</span>
          <span slot="no-more"></span>
        </infinite-loading>
    </ul>
        
    <div class="sa-ftr-btn">
      <button @click="goback()" class="sa-btn-large sa-btn-primary sa-btn-block-xs">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import { pro_url, oh_url } from "../../../../../config/endpoints";
import axios from 'axios';
const api = '//hn.algolia.com/api/v1/search_by_date?tags=story';
export default {
props: ['drugs'],
 components: {
    "infinite-loading": InfiniteLoading,
  },
data() {
  return {
    scientific_name: null,
    scientificNames: [],
    infiniteId: +new Date(),
    page: 1,
    scientific_search:'',
    picked: 'One'
  }
},
methods: {
  goback(){
    if(this.scientific_name){
      this.$parent.$parent.drugObj.scientific_name = this.scientific_name
    }
    this.$parent.$parent.ScientificFlag = false
  },
  changeType() {
      this.page = 1;
      this.scientificNames = [];
      this.infiniteId += 1;
    },
   infiniteHandler($state) {
      axios.get(api, {
        params: {
          page: this.page,
        },
      }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.scientificNames.push(...data.hits);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    getScientificData($state) {
      if(this.scientific_search.length >= 3 || this.scientific_search.length == 0){
        let _self = this
     let data = {
          limit: 30,
	        page: this.page,
          scientific_search: this.scientific_search
          }
      if(this.drugs && this.drugs.drug_nm){
        data.drug_nm = this.drugs.drug_nm
      }    
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/drugsList`,
          body: data,
        })
        .then((response) => {
          if ((response.status = 1000)) {
            if (response && response.status === 1000 && response.data && response.data.data && response.data.data.scientifi_names && response.data.data.scientifi_names.length) {
                _self.page += 1
                // _self.scientificNames.push(...response.data.data.scientifi_names);
                // for filering out the duplicate scientific names
                const uniqueNames = new Set([..._self.scientificNames, ...response.data.data.scientifi_names]);
              _self.scientificNames = [...uniqueNames];
                $state.loaded()
              } else {
                  $state.complete()
              }
          }
        })
        .catch((e) => {
          // console.log(e)
        });
      }
      
    },
},
mounted(){
 //this.scientificNames = this.scientificName
}
}
</script>
